import React, { Component } from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { addResponsivity, up, down, between } from "../lib/styles"
import { Col, Row, Text, Title, Gap, Link, DashedLine, HexaImage } from "."
import T from "../lib/intl/T"

const Wrapper = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    flex-direction: column;
    width: calc(100% + 8px);
    margin: 0 -4px;

    ${up("mobile")} {
      width: calc(100% + 35px);
      margin: 0 0 0 -35px;
      /* some reponsivity */
    }
  `}
`

class ProcedureWidget extends Component {
  render() {
    const { procedure } = this.props
    if (!procedure) {
      return null
    }
    return (
      <Wrapper>
        <Col>
          <Gap gap="24px" mobileGap="16px" />
          <DashedLine />
          <Gap gap="26px" mobileGap="32px" />
          <Row alignItems="center" mobileAlignItems="flex-start" bp={680}>
            <Col maxWidth="118px" width="100%" minWidth="80px" shrink="10">
              <Link to={`${Link.PROCEDURES}/${procedure.slug}`}>
                <HexaImage image={procedure.thumbImage.filename.thumb.gatsbyImageData} />
              </Link>
            </Col>

            <Gap gap="24px" mobileGap="16px" />
            <Col>
              <Link to={`${Link.PROCEDURES}/${procedure.slug}`}>
                <Title.SmallerTitle margin="0 16px 0 0">
                  {procedure.name}
                </Title.SmallerTitle>
              </Link>
              <Gap gap="4px" mobileGap="4px" />
              <Row
                alignItems="center"
                mobileAlignItems="flex-start"
                responsive
                bp={680}
              >
                <Text maxWidth="357px">{procedure.perex}</Text>
                <Gap gap="32px" mobileGap="8px" bp={680} />
                <Col shrink="0">
                  <Link.BasicLink to={`${Link.PROCEDURES}/${procedure.slug}`}>
                    <T>Více o zákroku</T>
                  </Link.BasicLink>
                </Col>
                <Gap.Fluid max="36px" min="16px" desktop />
              </Row>
            </Col>
          </Row>

          <Gap gap="26px" mobileGap="32px" />
          <DashedLine />
          <Gap gap="24px" mobileGap="16px" />
        </Col>
      </Wrapper>
    )
  }
}

ProcedureWidget.propTypes = {}

export default ProcedureWidget
